import clearNewCategoryState from '../actions/clearNewCategoryState';
import setCategoryNameOnNewCategory from '../actions/setCategoryNameOnNewCategory';
import store from '../store/store';
import { observer } from 'mobx-react';
import { NewCategoryCreateTrigger } from '../datapoints';
import { ITextField, TextField } from 'office-ui-fabric-react/lib/components/TextField';
import { KeyCodes } from 'office-ui-fabric-react/lib/Utilities';
import {
    isCategoryNameDuplicate,
    isCategoryNameEmptyOrWhitespace,
    getMasterCategoryList,
} from 'owa-categories';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';

export interface CategoryTextFieldProps {
    id: string;
    onBlurOnTextField: (evt: React.FocusEvent<EventTarget>) => void;
    trySaveNewCategory: (createSource: NewCategoryCreateTrigger) => void;
}

@observer
export default class CategoryTextField extends React.Component<CategoryTextFieldProps, {}> {
    private textField: ITextField;

    focus() {
        this.textField.focus();
    }

    render() {
        return (
            <TextField
                autoFocus={true}
                componentRef={ref => {
                    this.textField = ref;
                }}
                onBlur={this.props.onBlurOnTextField}
                onChanged={setCategoryNameOnNewCategory}
                onGetErrorMessage={this.onGetErrorMessage}
                onKeyDown={this.onTextFieldKeyDown}
                placeholder={strings.options_category_textfield_placeholder}
                value={store.newCategory.Name}
            />
        );
    }

    private onTextFieldKeyDown = (evt: React.KeyboardEvent<EventTarget>) => {
        // Need stop propagation to prevent discard the whole category settings
        evt.stopPropagation();
        switch (evt.which) {
            case KeyCodes.enter:
                this.props.trySaveNewCategory(NewCategoryCreateTrigger.OnEnterOnTextField);
                break;

            case KeyCodes.escape:
                clearNewCategoryState();
                break;
        }
    };

    private onGetErrorMessage = (value: string): string => {
        // Do not show any error message if user hasn't started typing
        if (!this.textField || this.textField.value === '') {
            return undefined;
        }

        if (isCategoryNameEmptyOrWhitespace(this.textField.value)) {
            return strings.options_empty_category_error;
        }

        if (isCategoryNameDuplicate(this.textField.value, getMasterCategoryList())) {
            return strings.options_duplicate_category_error;
        }

        // Do not show any error message
        return undefined;
    };
}
